var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"width":_vm.imgWidth,"height":_vm.imgHeight,"src":_vm.src,"role":"button","preview":_vm.group,"preview-text":_vm.previewText,"onerror":_vm.store.state.commonStore.noPic}})}
var staticRenderFns = []

export { render, staticRenderFns }